import { createAction } from 'redux-actions';
import { createSuccessAction, createFailureAction, createActionBundle } from 'utilities/request';

export const {
  fetch: fetchOrganization,
  request: requestOrganization,
  success: requestOrganizationSuccess,
  failure: requestOrganizationFailure,
} = createActionBundle('ORGANIZATION');

export const {
  fetch: initOrganizationEdit,
  request: requestOrganizationEdit,
  success: requestOrganizationEditSuccess,
  failure: requestOrganizationEditFailure,
} = createActionBundle('ORGANIZATION/EDIT');

export const requestAllPractitioners = createAction('REQUEST/ALL_PRACTITIONERS');
export const requestAllPractitionersSuccess = createSuccessAction(requestAllPractitioners);
export const requestAllPractitionersFailure = createFailureAction(requestAllPractitioners);

export const {
  fetch: initEditSuperCareteamUsers,
  request: requestEditSuperCareteamUsers,
  success: requestEditSuperCareteamUsersSuccess,
  failure: requestEditSuperCareteamUsersFailure,
} = createActionBundle('SUPER_CARETEAM/EDIT');
